import { useContext } from "react";

// context
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// components
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import SalaryDetails from "./SalaryDetails";

const SalaryDetailPop = ({ seqNewSettlementPayroll, setRefetch }: any) => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "SALARY_DETAIL_POP",
      open: { salaryDetailPop: false },
    });
  };

  return (
    <CustomDialog open={state.salaryDetailPop} onClose={handleClose}>
      <PopupHeader title="급여 상세 내역" onClickBack={handleClose} />
      <SalaryDetails seqNewSettlementPayroll={seqNewSettlementPayroll} setRefetch={setRefetch} />
    </CustomDialog>
  );
};

export default SalaryDetailPop;
